/* Ground Central — custom variant listbox on product cards.
   Document-level delegation, so it covers every .gc-select on the page
   regardless of which section rendered it (best-sellers, collection grid...). */
(function () {
  if (window.gcVariantSelectReady) return;
  window.gcVariantSelectReady = true;

  function panelOf(sel) { return sel.querySelector('.gc-select__panel'); }
  function toggleOf(sel) { return sel.querySelector('.gc-select__toggle'); }
  function optionsOf(sel) {
    return Array.prototype.slice.call(sel.querySelectorAll('.gc-select__option'));
  }

  function close(sel) {
    if (!sel || !sel.classList.contains('is-open')) return;
    sel.classList.remove('is-open');
    toggleOf(sel).setAttribute('aria-expanded', 'false');
    panelOf(sel).hidden = true;
    var card = sel.closest('.gc-card');
    if (card) card.classList.remove('gc-card--select-open');
  }

  function closeAll(except) {
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-gc-select].is-open'),
      function (s) { if (s !== except) close(s); }
    );
  }

  function open(sel) {
    closeAll(sel);
    sel.classList.add('is-open');
    toggleOf(sel).setAttribute('aria-expanded', 'true');
    panelOf(sel).hidden = false;
    // .gc-card gets a transform on hover/focus-within, which creates a
    // stacking context; without this the panel hides behind the next card.
    var card = sel.closest('.gc-card');
    if (card) card.classList.add('gc-card--select-open');
  }

  function choose(sel, option) {
    if (option.getAttribute('aria-disabled') === 'true') return;
    optionsOf(sel).forEach(function (o) {
      o.classList.remove('is-selected');
      o.setAttribute('aria-selected', 'false');
    });
    option.classList.add('is-selected');
    option.setAttribute('aria-selected', 'true');
    sel.querySelector('[data-gc-select-value]').textContent = option.dataset.label;
    sel.querySelector('[data-gc-select-input]').value = option.dataset.value;

    // Price and struck-through compare-at price are separate spans inside
    // .gc-card__price; the fallback covers cards rendered before that split.
    var card = sel.closest('.gc-card');
    var price = card && (card.querySelector('[data-gc-card-price]') || card.querySelector('.gc-card__price'));
    if (price && option.dataset.price) price.textContent = option.dataset.price;
    var compare = card && card.querySelector('[data-gc-card-compare]');
    if (compare) {
      compare.textContent = option.dataset.compare || '';
      compare.hidden = !option.dataset.compare;
    }

    close(sel);
    toggleOf(sel).focus();
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    var toggle = e.target.closest('.gc-select__toggle');
    if (toggle) {
      var sel = toggle.closest('[data-gc-select]');
      if (sel.classList.contains('is-open')) { close(sel); } else { open(sel); }
      return;
    }

    var option = e.target.closest('.gc-select__option');
    if (option) {
      choose(option.closest('[data-gc-select]'), option);
      return;
    }

    if (!e.target.closest('[data-gc-select]')) closeAll(null);
  });

  document.addEventListener('keydown', function (e) {
    if (!e.target.closest) return;
    var sel = e.target.closest('[data-gc-select]');
    if (!sel) return;

    var isOpen = sel.classList.contains('is-open');
    var options = optionsOf(sel);

    if (e.key === 'Escape' && isOpen) {
      e.preventDefault();
      close(sel);
      toggleOf(sel).focus();
      return;
    }

    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault();
      if (!isOpen) {
        open(sel);
        (sel.querySelector('.gc-select__option.is-selected') || options[0]).focus();
        return;
      }
      var i = options.indexOf(document.activeElement);
      var next = e.key === 'ArrowDown' ? i + 1 : i - 1;
      if (next < 0) next = options.length - 1;
      if (next >= options.length) next = 0;
      options[next].focus();
      return;
    }

    if ((e.key === 'Enter' || e.key === ' ') && e.target.classList.contains('gc-select__option')) {
      e.preventDefault();
      choose(sel, e.target);
    }
  });
})();
